import { configureStore } from '@reduxjs/toolkit'
import authReducer from './authSlice'
import providerAuthReducer from './providerAuthSlice'
import { api } from '@/services/api'
import { providerApi } from '@/services/providerApi'

export const store = configureStore({
  reducer: {
    auth: authReducer,
    providerAuth: providerAuthReducer,
    [api.reducerPath]: api.reducer,
    [providerApi.reducerPath]: providerApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(api.middleware, providerApi.middleware),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
